import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { TeamPurchaseOrderPhase, Workspace, WorkspacePurchaseOrderPhase } from '@/hooks/api/models';

/**
 * 2580. ワークスペース発注フェーズ名変更
 * [PUT] /workspaces/:identifier/workspace_purchase_order_phases/:phase_id
 */
type Props = {
  identifier: string;
  phase_id: number;
  label: string;
};
export const updateWorkspacePurchaseOrderPhases = (props: Props): Promise<WorkspacePurchaseOrderPhase> => {
  return axios.put(`/api/workspaces/${props.identifier}/workspace_purchase_order_phases/${props.phase_id}`, props);
};

export const useUpdateWorkspacePurchaseOrderPhases = () => {
  return useMutation({
    mutationFn: updateWorkspacePurchaseOrderPhases,
  });
};
